import React, { useState, useEffect } from 'react';
import { EnquiryForm, useLazyFetchEnquiryFormQuery } from '@modules/EnquiryForm';
import './Enquiry.scss';

export default function EnquiryPage() {
  const [showForm, setShowForm] = useState(true);
  const enqType = (document.getElementById('EnquiryType') as HTMLInputElement).value;

  const [fetchEnquiryForm, { data: formData }] = useLazyFetchEnquiryFormQuery();

  useEffect(() => {
    fetchEnquiryForm({
      enquiryType: enqType,
    }).then(() => {
      localStorage.removeItem('CategoryID');
    });
  }, [enqType]);

  const getBackButtonUrl = () => {
    let backUrl;
    const localStorageItem = window.localStorage.getItem('backButtonUrl');

    if (!localStorageItem) {
      const url = window.location.pathname?.split('/')?.filter((e) => e);
      url.length > 0 ? url.pop() : '';
      backUrl = url.length > 1 ? url.join('/') : url.join('');
      return `/${backUrl}`;
    } else {
      return localStorageItem;
    }
  };

  // Clearing the state when page is refreshed
  window.addEventListener('beforeunload', function (event) {
    if (window.location.reload) {
      window.history.replaceState(null, '', window.location.href);
    }
  });

  return (
    <div className='l-section l-section-100'>
      <div className='l-content l-page-center'>
        <section className='l-section l-section-100 l-section-padding'>
          {showForm && formData?.Page?.FormDescription && (
            <a href={getBackButtonUrl()}>
              <i className='icon-arrow-left'></i>
            </a>
          )}
          <EnquiryForm
            formData={formData}
            type={enqType}
            onSubmitSuccess={() => {
              setShowForm(false);
            }}
            onBackClick={() => {
              setShowForm(true);
            }}
          />
        </section>
      </div>
    </div>
  );
}
